import LabeledInput from "../UniversalEditModal/components/LabeledInput";
import PasswordInput from "../UniversalEditModal/components/PasswordInput";
import ButtonSave from "../UniversalEditModal/components/ButtonSave";
import { useFormContext } from "react-hook-form";
import NotImplementedWrap from "../UniversalEditModal/components/NotImplementedWrap";

type PassField = "password" | "newPassword" | "confirmPassword" | null;

interface Props {
  openField: PassField;
  toggle: (f: Exclude<PassField, null>) => void;
  hasUnsavedChanges: boolean;
}

export default function AccountTab({
  openField,
  toggle,
  hasUnsavedChanges,
}: Props) {
  const {
    watch,
    register,
    formState,
    setValue
  } = useFormContext();

  const isOpen = (f: Exclude<PassField, null>) => openField === f;

  return (
    <>
      <div className="universaleditmodal-right-content">
        <div className="universaleditmodal-right-content-text">
          <div className="universaleditmodal-right-content-text-title">
            Аккаунт
          </div>
          <div className="universaleditmodal-right-content-text-description">
            Данные для входа
          </div>
        </div>
        <LabeledInput
          label="Логин"
          inputName="name"
          errors={formState.errors}
          watch={watch}
          {...register("name", {
            minLength: 3,
            maxLength: 40,
            pattern: /^[a-zA-Z0-9-_]+$/
          })}
        />
        {formState.errors.username?.type === 'minLength' && (
          <p className="universaleditmodal-right-content-invalid-message">
            Логин должен содержать минимум 3 символа
          </p>
        )}
        {formState.errors.username?.type === 'maxLength' && (
          <p className="universaleditmodal-right-content-invalid-message">
            Логин должен содержать максимум 40 символов
          </p>
        )}
        {formState.errors.username?.type === 'pattern' && (
          <p className="universaleditmodal-right-content-invalid-message">
            Допустимы только латиница, цифры, дефис и нижнее подчеркивание
          </p>
        )}
        <NotImplementedWrap>
          <PasswordInput
            placeholder="Пароль"
            isVisible={isOpen("password")}
            toggle={() => toggle("password")}
            inputName="password"
            register={register}
            errors={formState.errors}
          />
        </NotImplementedWrap>
        <NotImplementedWrap>
          <PasswordInput
            placeholder="Новый пароль"
            isVisible={isOpen("newPassword")}
            toggle={() => toggle("newPassword")}
            inputName="newPassword"
            register={register}
            errors={formState.errors}
          />
        </NotImplementedWrap>
        <NotImplementedWrap>
          <PasswordInput
            placeholder="Подтвердите пароль"
            isVisible={isOpen("confirmPassword")}
            toggle={() => toggle("confirmPassword")}
            inputName="confirmPassword"
            register={register}
            errors={formState.errors}
          />
        </NotImplementedWrap>
      </div>
      <div className="buttonsave-privacy">
        <ButtonSave hasUnsavedChanges={hasUnsavedChanges} />
      </div>
    </>
  );
}